<template>
    <v-app-bar
        v-if="isFullPage"
        height="56px"
        app
        color="white"
        :class="$route.query.ukuwinversion ? 'mx-3 mt-4' : ''"
        class="global-elevation"
    >
        <v-app-bar-nav-icon @click="close_click">
            <v-icon class="n3--text">mdi-arrow-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title class="pl-0">{{ view_title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <icon-button
            icon="BookmarkPlus"
            :color="taskData.is_extra ? 'orange' : 'n3'"
            @click="toggle_field('is_extra')"
        />
        <icon-button
            icon="Flag"
            :color="taskData.is_important ? 'orange' : 'n3'"
            @click="toggle_field('is_important')"
        />
        <v-menu
            v-if="menuItems.length > 0"
            left
            offset-y
        >
            <template v-slot:activator="{ on }">
                <icon-button
                    :on="on"
                    icon="MoreVertical"
                />
            </template>
            <v-list>
                <v-list-item
                    v-for="(item, i) in menuItems"
                    :key="i"
                    @click="action_click(item.action)"
                >
                    <v-list-item-content>
                        <label
                            v-if="item.action === 'add_attachment'"
                            for="userfile735"
                            style="cursor: pointer;"
                        >
                            {{ item.title }}
                        </label>
                        <v-list-item-title v-else>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import { $t } from "@/i18n";
import { computed } from "@vue/composition-api";

export default {
    name: "TaskMobileToolbar",
    props: {
        isFullPage: {
            type: Boolean,
            default: false
        },
        taskData: {
            type: Object,
            default: () => null
        },
        menuItems: {
            type: Array,
            default: () => []
        },
    },
    setup(props, ctx) {
        const view_title = computed(function () {
            if (props.taskData === 0) return "";
            if (props.taskData.id === 0)
                return props.taskData.recurrence_rule == null ? $t("New task") : $t("New recurring task");
            else return props.taskData.recurrence_rule == null ? $t("Task") : $t("Recurring task");
        });
        
        const toggle_field = function (field_name) {
            ctx.emit("toggle_field", field_name);
        };

        const action_click = function (action) {
            ctx.emit("action_click", action);
        }

        const close_click = function () {
            ctx.emit('close_click');
        }

        return {
            toggle_field,
            action_click,
            close_click,
            view_title
        }
    }
}
</script>
